export default __webpack_public_path__ + "static/media/guidelines-7.072138e0.jpeg";